 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"blog~portfolio~spotlight":"blog~portfolio~spotlight","portfolio~spotlight":"portfolio~spotlight","portfolio":"portfolio","calendar":"calendar","chat":"chat","absence":"absence","accountstatement":"accountstatement","assessment":"assessment","blog":"blog","spotlight":"spotlight","booking":"booking","notices":"notices","messages":"messages","permissionslips":"permissionslips","spotlightMyUpload":"spotlightMyUpload","favourites":"favourites","newsletters":"newsletters","contact":"contact","documents":"documents","guidance":"guidance","home":"home","mychild":"mychild","reports":"reports","settings":"settings","sickbay":"sickbay"}[chunkId]||chunkId) + "." + {"blog~portfolio~spotlight":"a1aaf9ff","portfolio~spotlight":"87cd7e28","portfolio":"84966b99","calendar":"835a902c","chat":"2afcb8d3","chunk-2d20866a":"b6557874","chunk-69d1f143":"425564bd","absence":"6ca8e6e8","accountstatement":"d4ae3972","assessment":"1ea93421","blog":"70c141e5","spotlight":"930089cd","booking":"42e03493","chunk-497d95ab":"9eec09e2","chunk-99cbe5b4":"40bd8ee2","notices":"2e24c22e","chunk-b0e375ca":"92a0460a","messages":"ab77dfd9","permissionslips":"6ffdbeb9","spotlightMyUpload":"e8105daa","chunk-733860ae":"faf7df6a","favourites":"4e854802","newsletters":"7cdeeebf","contact":"49e8e4a7","documents":"69ec0b77","guidance":"1b7d5c6d","home":"bc3fc49b","mychild":"0d7da033","reports":"0eef413a","settings":"a5b7627b","sickbay":"f16eaa89","chunk-2d0b16d2":"033262fe","chunk-2d0e198e":"6fc123ea","chunk-2d0e961c":"1e09b03c","chunk-2d225f19":"3dd7a2c4","chunk-c128180e":"6929f7e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"portfolio~spotlight":1,"calendar":1,"chat":1,"chunk-69d1f143":1,"absence":1,"assessment":1,"blog":1,"spotlight":1,"booking":1,"chunk-497d95ab":1,"chunk-99cbe5b4":1,"notices":1,"chunk-b0e375ca":1,"permissionslips":1,"spotlightMyUpload":1,"chunk-733860ae":1,"favourites":1,"newsletters":1,"contact":1,"guidance":1,"home":1,"mychild":1,"reports":1,"settings":1,"chunk-c128180e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"blog~portfolio~spotlight":"blog~portfolio~spotlight","portfolio~spotlight":"portfolio~spotlight","portfolio":"portfolio","calendar":"calendar","chat":"chat","absence":"absence","accountstatement":"accountstatement","assessment":"assessment","blog":"blog","spotlight":"spotlight","booking":"booking","notices":"notices","messages":"messages","permissionslips":"permissionslips","spotlightMyUpload":"spotlightMyUpload","favourites":"favourites","newsletters":"newsletters","contact":"contact","documents":"documents","guidance":"guidance","home":"home","mychild":"mychild","reports":"reports","settings":"settings","sickbay":"sickbay"}[chunkId]||chunkId) + "." + {"blog~portfolio~spotlight":"31d6cfe0","portfolio~spotlight":"3ccee72e","portfolio":"31d6cfe0","calendar":"71dbe1fd","chat":"fc8cc260","chunk-2d20866a":"31d6cfe0","chunk-69d1f143":"cdf0c9e9","absence":"80a5642e","accountstatement":"31d6cfe0","assessment":"ac823d3c","blog":"e8cf0fd5","spotlight":"526e3aca","booking":"d3195605","chunk-497d95ab":"076ea886","chunk-99cbe5b4":"ef307a58","notices":"d4780fd2","chunk-b0e375ca":"f285793e","messages":"31d6cfe0","permissionslips":"a1b3d4ab","spotlightMyUpload":"cd1688dd","chunk-733860ae":"726abcf1","favourites":"d4780fd2","newsletters":"726abcf1","contact":"0a538b65","documents":"31d6cfe0","guidance":"884b2aa2","home":"07684584","mychild":"ad1a5645","reports":"0a538b65","settings":"edfc2b14","sickbay":"31d6cfe0","chunk-2d0b16d2":"31d6cfe0","chunk-2d0e198e":"31d6cfe0","chunk-2d0e961c":"31d6cfe0","chunk-2d225f19":"31d6cfe0","chunk-c128180e":"844a6ecd"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
